import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { WorkspaceDiv } from '../component/workspace/WorkspaceDiv';

export const WorkspacePage = () => (
  <MainPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<WorkspaceDiv />}
  />
);
